__turbopack_context__.v({
  "footer": "V1a3ta_footer",
  "main": "V1a3ta_main",
  "max-width-container": "V1a3ta_max-width-container",
  "page-container": "V1a3ta_page-container",
});
